<template>
  <div class="phoneMy">
    <!-- 头像名字 -->
    <div class="phoneMy_head">
      <div class="phoneMy_head_img">
        <img :src="userInfo.photo ? userInfo.photo : normalImg" alt="" />
      </div>
      <div class="phoneMy_head_Title">
        <p>{{ userInfo.real_name ? userInfo.real_name : "请完善姓名..." }}</p>
        <p>{{ userInfo.cellphone }}</p>
        <p>{{ userInfo.flow_status_name }}</p>
      </div>
    </div>
    <!-- 项目列表 -->
    <div class="phoneMy_list">
      <div
        class="phoneMy_list_li"
        v-for="(item, index) in titleList"
        @click="navToPage(item.name)"
        :key="index"
      >
        <div class="phoneMy_list_li__left">
          <img class="phoneMy_list_li__img" :src="item.path" alt="" />
          <p>{{ item.label }}</p>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <!-- 退出登录 -->
    <div class="phoneMy_loginOut" @click="loginOut">
      <p>退出登录</p>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="96%"
      :before-close="handleClose"
    >
      <div style="display: flex; justify-content: center">
        <phoneQrcode></phoneQrcode>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getVipUser, registerPaper } from "../../api/moudles/user.js";
import phoneQrcode from "../../components/phoneQrcode.vue";
export default {
  data() {
    return {
      dialogVisible: false,
      normalImg: require("../../assets/img/userIndex/head.png"),
      userInfo: {},
      titleList: [
        {
          label: "基本信息",
          path: require("../../assets/img/phoneIndex/basic.png"),
          name: "phoneBasic",
        },
        {
          label: "证书信息",
          path: require("../../assets/img/phoneIndex/certirl.png"),
          name: "phoneCertInfo",
        },
        {
          label: "消息中心",
          path: require("../../assets/img/phoneIndex/notice.png"),
          name: "phoneNotice",
        },
        {
          label: "修改密码",
          path: require("../../assets/img/phoneIndex/password.png"),
          name: "phonePassword",
        },
      ],
    };
  },
  components: {
    phoneQrcode,
  },
  created() {
    if (this.$store.state.user.userVip !== false) {
      this.userInfo = this.UserInfo;
      // this.getVipUser()
    } else {
      this.userInfo.real_name = `用户    ${this.$store.state.user.noVipPhone}`;
      this.titleList = [
        {
          label: "消息中心",
          path: require("../../assets/img/phoneIndex/notice.png"),
          name: "phoneNotice",
        },
        // {
        //   label: "注册会员",
        //   path: require("../../assets/img/phoneIndex/user.png"),
        //   name: "register",
        // },
      ];
    }
    this.getUserPaper();
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    UserInfo: (state) => state.user.userInfo,
  }),
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    navToPage(name) {
      if (name) {
        if (name == "recommend") {
          this.dialogVisible = true;
        } else {
          this.$router.push({
            name,
          });
        }
      }
    },
    // 获取用户信息
    async getVipUser() {
      await getVipUser({
        success: (res) => {
          // console.log('用户信息', res)
          this.userInfo = res.data;
        },
      });
    },
    async getUserPaper() {
      await registerPaper({
        success: (rss) => {
          // console.log('用户信息', rss)
          if (rss.data.is_recommend == "1") {
            this.titleList.push({
              label: "推荐码",
              path: require("../../assets/img/phoneIndex/qrcode.png"),
              name: "recommend",
            });
          }
        },
      });
    },
    // 退出登录
    loginOut() {
      this.$store.commit("user/RESET_INFO");
      setTimeout(() => {
        this.$message({
          message: "退出成功，请重新登录!",
          type: "success",
        });
      }, 500);
      if (this.$route.meta.requireAuth) {
        // 需要登录
        this.$router.replace("/phoneIndex/login");
      }
    },
  },
};
</script>

<style scoped>
.phoneMy {
  height: 90vh;
  background-image: linear-gradient(to bottom, #ed653b 40%, #f5f5f5 100%);
  background-repeat: no-repeat;
}

.phoneMy_head {
  width: 100%;
  height: 250px;
  background-image: url("../../assets/img/userIndex/bgc.png");
  background-position: 70% 0px;
  background-size: cover;
  display: flex;
  padding: 20px 20px;
  box-sizing: border-box;
}

.phoneMy_head_img {
  width: 90px;
  height: 90px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 50%;
}

.phoneMy_head_img img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}

.phoneMy_head_Title {
  color: #fff;
}

.phoneMy_head_Title p {
  padding: 5px 10px;
}

.phoneMy_list {
  height: auto;
  width: 90%;
  margin-left: 5%;
  background-color: #fff;
  border-radius: 15px;
  margin-top: -100px;
  padding: 10px 0;
}

.phoneMy_list_li {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
}

.phoneMy_list_li:last-child {
  border-bottom: 1px solid #fff;
}

.phoneMy_list_li__left {
  display: flex;
  align-items: center;
}

.phoneMy_list_li__left p {
  margin-left: 20px;
  padding-top: 2px;
}

.phoneMy_list_li__img {
  width: 25px;
  height: 25px;
}

.phoneMy_loginOut {
  width: 90%;
  margin-left: 5%;
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
  height: 50px;
  background-color: #c22c25;
  color: #fff;
  margin-top: 50px;
  margin-bottom: 80px;
}
</style>
